import { FormikProps } from "formik";
import InputRadio from "./InputRadio";
import ValidationErrorMessage from "./ValidationErrorMessage";
import { ChangeEventHandler } from "react";
import IsRequired from "./common/IsRequired";

export function BooleanFormControl<U>({
  config,
  formik,
  disabled,
  onChange,
  value,
}: {
  config: IBooleanEdit<U>;
  formik: FormikProps<any>;
  value?: boolean | undefined;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
}) {
  const { setFieldValue } = formik;
  const { id, label, isRequired, label1, label2 } = config;

  return (
    <>
      <label className="form-label" htmlFor={id}>
        {label}
        {isRequired && <IsRequired />}
      </label>
      <div className="mt-1">
        <InputRadio
          className={
            formik.touched[id] && (formik as any).errors[id]
              ? " is-invalid"
              : ""
          }
          disabled={disabled}
          label={label1 ?? "Ja"}
          name={id}
          id={id + "-option1"}
          checked={value === true}
          onChange={onChange ? onChange : () => setFieldValue(id, true, true)}
        />
        <InputRadio
          className={
            formik.touched[id] && (formik as any).errors[id]
              ? " is-invalid"
              : ""
          }
          disabled={disabled}
          label={label2 ?? "Nej"}
          name={id}
          id={id + "-option2"}
          checked={value === false}
          onChange={onChange ? onChange : () => setFieldValue(id, false, true)}
        />
      </div>
      <ValidationErrorMessage
        touched={formik.touched[id]}
        errorMessage={(formik as any).errors[id]}
      />
    </>
  );
}
